var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons';
import { CaseStatus, SystemEndReason } from '@debbie/common/dist/cases';
import { c, h } from '@debbie/cortex/dist';
import * as casesAPI from '@debbie/cortex/dist/api/cases';
import { FeatherIconsUnqiueMatch } from './DesignSystem/elements/FeatherIcons';
import { Col, Row } from './Grid';
import { ButtonGroup, Button, Modal, Messages, Input } from '.';
const CaseStatusSelector = (props) => {
    const singleCase = props.case;
    const lang = useSelector((s) => s.lang);
    const endReasonsSource = useEndReasons();
    const [endModalOpen, setEndModalOpen] = useState(false);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errors, setErrors] = useState([]);
    const [query, setQuery] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const toggleEndModal = () => {
        setEndModalOpen(!endModalOpen);
    };
    const toggleErrorModal = () => {
        setErrorModalOpen(!errorModalOpen);
    };
    const changeCaseStatus = (status, endReasonId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield casesAPI.patch(singleCase.caseId, {
                status,
                endReasonId,
            });
            // Reload case
            yield c.cases.getById(props.case.id);
            yield c.customers.getById(singleCase.customerId);
        }
        catch (error) {
            alert(error);
        }
        setLoading(false);
        setErrors([]);
        setEndModalOpen(false);
        setErrorModalOpen(false);
    });
    const onEnd = (endReasonId) => {
        setEndModalOpen(false);
        return changeCaseStatus(CaseStatus.ENDED, endReasonId);
    };
    const endReasons = (h.hasData(endReasonsSource) ? endReasonsSource.data : []).filter((reason) => {
        var _a;
        if ([SystemEndReason.FireAndForget, SystemEndReason.Deleted].includes(reason.handle)) {
            return false;
        }
        return (!query ||
            `${(_a = lang.endReason[reason.handle]) !== null && _a !== void 0 ? _a : reason.label}`
                .toLowerCase()
                .indexOf(query.toLowerCase()) !== -1);
    });
    const endReasonElements = endReasons.map((reason, i) => (React.createElement(EndReasonButton, { key: reason.id, endReason: reason, onClick: () => {
            return onEnd(reason.id);
        }, active: i === activeIndex })));
    return (React.createElement("div", null,
        [CaseStatus.PENDING, CaseStatus.VERIFIED].includes(singleCase.status) && (React.createElement(ButtonGroup, null,
            CaseStatus.PENDING === singleCase.status && (React.createElement(Button, { theme: "secondary", loading: loading, size: "small", className: "ui-test-48a86ed2", onClick: () => {
                    changeCaseStatus(CaseStatus.VERIFIED);
                } }, lang.cases.verify)),
            React.createElement(Button, { theme: "secondary", loading: loading, size: "small", onClick: toggleEndModal }, lang.cases.end))),
        [CaseStatus.ENDED].includes(singleCase.status) && (React.createElement(ButtonGroup, null,
            React.createElement(Button, { theme: "secondary", loading: loading, size: "small", onClick: () => {
                    changeCaseStatus(CaseStatus.VERIFIED);
                } }, lang.cases.reVerify))),
        endModalOpen && (React.createElement(Modal, { maxWidth: "1300px", header: lang.cases.endCase, onToggle: toggleEndModal },
            React.createElement(Messages, { messages: errors, type: 'error' }),
            React.createElement("h3", null, lang.cases.choosEndReason),
            React.createElement(Input, { placeholder: "S\u00F8g", autofocus: true, value: query, onChange: (e) => {
                    setQuery(e.target.value);
                    setActiveIndex(0);
                }, onKeyDown: (e) => {
                    const k = e.key;
                    let delta = 0;
                    if (k == 'ArrowRight') {
                        delta++;
                    }
                    if (k == 'ArrowLeft') {
                        delta--;
                    }
                    if (k == 'ArrowUp') {
                        delta = delta - 6;
                    }
                    if (k == 'ArrowDown') {
                        delta = delta + 6;
                    }
                    if (k == 'Enter') {
                        const endReason = endReasons[activeIndex];
                        if (endReason) {
                            onEnd(endReason.id);
                        }
                    }
                    if (delta) {
                        e.preventDefault();
                        const newIndex = activeIndex + delta;
                        if (newIndex >= 0 && newIndex < endReasons.length) {
                            setActiveIndex(newIndex);
                        }
                    }
                } }),
            React.createElement(Row, null, endReasonElements))),
        errorModalOpen && (React.createElement(Modal, { maxWidth: "400px", header: "Errors", onToggle: toggleErrorModal },
            React.createElement(Messages, { messages: errors, type: "error" })))));
};
const iconEndReasonMatch = new Map([
    [SystemEndReason.AddressUnknown, 'Home'],
    [SystemEndReason.Bankruptcy, 'TrendingDown'],
    [SystemEndReason.ConflictOfInterest, 'Maximize2'],
    [SystemEndReason.CreditorUnresponsive, 'PhoneOff'],
    [SystemEndReason.Dead, 'Twitter'],
    [SystemEndReason.DebtRelief, 'Archive'],
    [SystemEndReason.Deleted, 'Trash2'],
    [SystemEndReason.NoDebt, 'AlertOctagon'],
    [SystemEndReason.Departed, 'Briefcase'],
    [SystemEndReason.ErrorCreditor, 'RotateCcw'],
    [SystemEndReason.ErrorUs, 'AlertCircle'],
    [SystemEndReason.Expiration, 'Watch'],
    [SystemEndReason.FireAndForget, 'EyeOff'],
    [SystemEndReason.ForcedDissolved, 'Meh'],
    [SystemEndReason.Irrecoverable, 'Frown'],
    [SystemEndReason.Merged, 'Minimize2'],
    [SystemEndReason.Minor, 'GitMerge'],
    [SystemEndReason.NegativePayoff, 'Percent'],
    [SystemEndReason.Objection, 'PhoneIncoming'],
    [SystemEndReason.OfferFromDebtor, 'Mail'],
    [SystemEndReason.OfferFromUs, 'FileText'],
    [SystemEndReason.Overpayment, 'ShoppingCart'],
    [SystemEndReason.Paid, 'CheckCircle'],
    [SystemEndReason.PartiallyPaid, 'Check'],
    [SystemEndReason.SmallCaseNotWanted, 'XCircle'],
    [SystemEndReason.Transferred, 'Share'],
    [SystemEndReason.Unidentified, 'UserX'],
    [SystemEndReason.Withdrawn, 'FileMinus'],
    [SystemEndReason.NoCourt, 'List'],
]);
const EndReasonButton = (props) => {
    var _a, _b;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { width: "2" },
            React.createElement(EndReasonContainer, { active: props.active, role: 'button', onClick: props.onClick },
                React.createElement(FeatherIconsUnqiueMatch, { query: (_a = iconEndReasonMatch.get(props.endReason.handle)) !== null && _a !== void 0 ? _a : 'MoreHorizontal' }),
                React.createElement("div", null, (_b = lang.endReason[props.endReason.handle]) !== null && _b !== void 0 ? _b : props.endReason.label)))));
};
const EndReasonContainer = styled.div `
  display: flex;
  gap: 30px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: 150px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  background-color: ${(props) => (props.active ? '#d8d8d8' : '#ffffff')};
  border: 1px solid lightgrey;
  transform: translateY(0px);
  transition: transform 0.2s;
  cursor: pointer;
  overflow: hidden;

  & > svg {
    height: 2em;
    width: 2em;
  }

  &:hover {
    transform: translateY(-3px);
  }
`;
export default CaseStatusSelector;
//# sourceMappingURL=CaseStatusSelector.js.map